import React from 'react'

import { usePermission } from '../_load/PermissionsLoader'
import { useSavePermissions } from './_requests/savePermissions'
import Switch from '../../../../components/form/Switch'

const PermissionProfileSwitch = ({ name, profile }) => {
  const permission = usePermission(profile, name) || {}
  const [enabled, setEnabled] = React.useState(permission?.enabled)

  React.useEffect(() => setEnabled(permission?.enabled), [permission.enabled])

  const handleError = () => setEnabled(enabled)
  const [save] = useSavePermissions(handleError)

  const handleChange = () => {
    setEnabled(!enabled)
    save([{ name, profileId: profile.id, enabled: !enabled }])
  }

  return <Switch onChange={handleChange} value={enabled} size="small" />
}

export default PermissionProfileSwitch
